<template>
    <div class="slide">

        <go-back />

        <div class="next" @click="next">
            <img src="/assets/img/icon-arrow-right-blue.svg" />
        </div>

        <div class="slide-container">

            <div class="question bigger">
                What are your <span>monthly income needs</span>?
            </div>

            <div class="answer answer-col">

                <div class="row">
                    <div class="col-md-12">

                        <div class="row">
                            <div class="col-md-4">
                                <v-text-field
                                label="Monthly income needs $" v-model="incomeNeeds" class="inputNumber"
                                ></v-text-field>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
import GoBack from "./GoBack";
export default {
    name: 'IncomeNeeds',
    components: {
        GoBack
    },
    mounted() {
        this.$store.dispatch('incomeNeeds/loadIncomeNeeds');
    },
    methods: {
        next() {
            this.$store.dispatch('incomeNeeds/saveIncomeNeeds');

            this.$router.push({ name: 'HavePensions' });
        }
    },
    computed: {
        incomeNeeds: {
            get () {
                return this.$store.getters["incomeNeeds/incomeNeeds"];
            },
            set (value) {
                this.$store.commit('incomeNeeds/setIncomeNeeds', value);
            }
        },
    }
}
</script>
